import type { SpriNavigationItem } from '@spri/components/navigation';

import { patientsBasicNavigationItem, positConnectBasicNavigationItem } from './navigation-shared-basic-items';

export const researchNavigation: SpriNavigationItem[] = [
  {
    id: 'schedule',
    title: 'Schedule',
    type: 'basic',
    icon: 'calendar',
    link: '/schedule',
  },
  {
    id: 'clinical-data',
    title: 'Clinical Data',
    type: 'collapsable',
    icon: 'clinical-data',
    children: [
      {
        id: 'surgery-forms',
        title: 'Surgery Forms',
        type: 'basic',
        link: '/clinical-data/surgery-form',
      },
      {
        id: 'exam-forms',
        title: 'Exam Forms',
        type: 'basic',
        link: '/clinical-data/exam-form',
      },
    ],
  },
  {
    id: 'patient-surveys',
    title: 'Patient Surveys',
    type: 'collapsable',
    icon: 'patient-survey',
    children: [
      {
        id: 'manual',
        title: 'Manual',
        type: 'basic',
        link: '/patient-surveys/manual',
      },
    ],
  },
  patientsBasicNavigationItem,
  positConnectBasicNavigationItem,
];

// Export the same navigation for different layout types
export const compactNavigation = researchNavigation;
export const futuristicNavigation = researchNavigation;
export const horizontalNavigation = researchNavigation;
